<h1 mat-dialog-title>{{ data.title | translate }}</h1>

<div mat-dialog-content>
  <p>{{data.message | translate}}</p>

  <form *ngIf="form" [formGroup]="form">
    <app-autocomplete [list]="list" [control]="getControl('choosenOne')" [label]="data.label"></app-autocomplete>
  </form>

</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onDismiss()">{{ "global.dialog.cancel" | translate }}</button>
  <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="onConfirm()">{{ "global.dialog.confirm" |
    translate }}</button>
</div>